if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.productList = this.querySelector('.shop-the-look-list');
      this.items = this.querySelectorAll('.shop-the-look-list-item');
      this.markers = this.querySelectorAll('.shop-the-look-product');
      if (this.productList) {
        this.onMouseMoveList();
        this.onTouchMoveList();
        if (this.isMobile()) {
          this.classList.add('is-mobile');
          this.productList.style.overflowY = 'hidden';
          this.markers.forEach(marker => {
            marker.addEventListener('click', this.onFocusMarker.bind(this));
          })
        } else {
          this.markers.forEach(marker => {
            marker.addEventListener('mouseenter', this.onFocusMarker.bind(this));

            if (this.dataset.keepHighlight == "false") {
              marker.addEventListener('mouseleave', () => {
                this.items.forEach(item => {
                  item.classList.remove('active')
                });
              });
            }
          })
        }
      }

    }
    onMouseMoveList() {
      const list = this.productList;
      const items = this.items;
      const _this = this;
      let isDragging = false;
      let pos = { top: 0, left: 0, x: 0, y: 0 };
      const onMouseDown = function (e) {
        e.preventDefault();
        isDragging = true;
        list.style.cursor = 'grabbing';

        pos = {
          left: list.scrollLeft,
          top: list.scrollTop,
          x: e.clientX,
          y: e.clientY,
        };

        list.addEventListener('mousemove', onMouseMove);
        list.addEventListener('mouseup', onMouseUp);
      };

      const onMouseMove = function (e) {
        e.preventDefault();
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        list.scrollTop = pos.top - dy;
        list.scrollLeft = pos.left - dx;

        items.forEach(i => {
          i.style.pointerEvents = 'none'
        })

        const listRect = list.getBoundingClientRect();
        if (e.clientX <= listRect.left || e.clientX >= listRect.right || e.clientY <= listRect.top || e.clientY >= listRect.bottom) {
          list.removeEventListener('mousemove', onMouseMove);
          list.removeEventListener('mouseup', onMouseUp);
        }

      };

      const onMouseUp = function () {
        isDragging = false;
        items.forEach((item, index) => {
          item.style.pointerEvents = 'all';
          list.removeEventListener('mousemove', onMouseMove);
          if (items.length > 1) {
            if (window.innerWidth < 750) {
              _this.snapToItemLeft(item, index, items, list);
            } else {
              if (list.dataset.layoutDirection == 'vertical') {
                _this.snapToItemTop(item, index, items, list);
              } else {
                _this.snapToItemLeft(item, index, items, list);
              }
            }
          }

          list.removeEventListener('mouseup', onMouseUp);
        })


      };

      window.addEventListener('mouseup', () => {
        list.style.cursor = 'grab';
      })

      list.addEventListener('mousedown', onMouseDown);

      list.addEventListener('mouseleave', () => {
        if (isDragging) {
          onMouseUp();
        }
      });
    }
    isMobile() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/android/i.test(userAgent)) {
        return true
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true
      }

      return false
    }
    onFocusMarker(e) {
      e.preventDefault();
      this.items.forEach(item => {
        if (item.dataset.id === e.target.dataset.id) {
          item.classList.add('active');

          this.productList.scroll({
            left: item.offsetLeft,
            top: item.offsetTop,
            behavior: 'smooth'
          })

          if (this.productList.scrollLeft + this.productList.clientWidth < item.offsetLeft + item.clientWidth || this.productList.scrollTop + this.productList.clientHeight < item.offsetTop + item.clientHeight) {
            this.productList.scroll({
              left: item.offsetLeft - (this.productList.clientWidth - item.clientWidth),
              top: item.offsetTop - (this.productList.clientHeight - item.clientHeight),
              behavior: 'smooth'
            })
          }
          if (e.type == 'click' && window.innerWidth < 768) {
            if (this.productList.getBoundingClientRect().bottom > window.innerHeight) {
              window.scroll({
                top: this.offsetTop + this.querySelector('.shop-the-look-wrapper').clientHeight - window.innerHeight + this.productList.clientHeight + 30,
                behavior: 'smooth'
              })
            }
          }


        }
        else
          item.classList.remove('active');
      })
    }
    snapToItemLeft(item, index, items, list) {
      const maxScrollLeft = list.scrollWidth - list.clientWidth
      let conditionalLeft = ((item.offsetLeft <= list.scrollLeft && (item.offsetLeft + item.clientWidth) > list.scrollLeft))
      if (index == 0) {
        conditionalLeft = (item.offsetLeft <= list.scrollLeft && (item.offsetLeft + (item.clientWidth * 0.5)) > list.scrollLeft);

      } else if (index > 0) {
        conditionalLeft = ((item.offsetLeft - (items[index - 1].clientWidth * 0.5)) <= list.scrollLeft && (item.offsetLeft + (item.clientWidth * 0.5)) > list.scrollLeft);
      }

      if (index == items.length - 1) {
        if (list.scrollLeft >= (maxScrollLeft - (item.clientWidth * 0.4))) {
          conditionalLeft = true;
        }
      }

      if (list.scrollLeft <= 40) {
        if (index == 0) {
          conditionalLeft = true;
        }
        else {
          conditionalLeft = false;
        }
      }

      if (conditionalLeft) {
        list.scroll({
          left: item.offsetLeft,
          behavior: "smooth"
        })
      }



    }
    snapToItemTop(item, index, items, list) {
      const maxScrollTop = list.scrollHeight - list.clientHeight
      let conditionalTop = (item.offsetTop <= list.scrollTop && (item.offsetTop + item.clientHeight) - list.offsetTop > list.scrollTop);
      if (index == 0) {
        conditionalTop = (item.offsetTop <= list.scrollTop && (item.offsetTop + (item.clientHeight * 0.5)) > list.scrollTop);
      } else if (index > 0) {
        conditionalTop = ((item.offsetTop - (items[index - 1].clientHeight * 0.5)) <= list.scrollTop) && ((item.offsetTop + (item.clientHeight * 0.5)) > list.scrollTop);
      }

      if (index == items.length - 1) {
        if (list.scrollTop >= (maxScrollTop - (item.clientHeight * 0.4))) {
          conditionalTop = true;
        }
      }

      if (list.scrollTop <= 40) {
        if (index == 0) {
          conditionalTop = true;
        }
        else {
          conditionalTop = false;
        }
      }

      if (conditionalTop) {
        list.scroll({
          top: item.offsetTop,
          behavior: "smooth"
        })

      }
    }
    onTouchMoveList() {
      const list = this.productList;
      const items = this.items;
      const _this = this;
      let isDragging = false;
      let pos = { top: 0, left: 0, x: 0, y: 0 };

      const onTouchStart = function (e) {
        const touch = e.touches[0];
        isDragging = true;
        list.style.cursor = 'grabbing';

        pos = {
          left: list.scrollLeft,
          top: list.scrollTop,
          x: touch.clientX,
          y: touch.clientY,
        };

        list.addEventListener('touchmove', onTouchMove);
        list.addEventListener('touchend', onTouchEnd);
      };

      const onTouchMove = function (e) {
        e.preventDefault();
        const touch = e.touches[0];
        const dx = touch.clientX - pos.x;
        const dy = touch.clientY - pos.y;

        list.scrollTop = pos.top - dy;
        list.scrollLeft = pos.left - dx;

        items.forEach(i => {
          i.style.pointerEvents = 'none';
        });

        const listRect = list.getBoundingClientRect();
        if (
          touch.clientX <= listRect.left ||
          touch.clientX >= listRect.right ||
          touch.clientY <= listRect.top ||
          touch.clientY >= listRect.bottom
        ) {
          list.removeEventListener('touchmove', onTouchMove);
          list.removeEventListener('touchend', onTouchEnd);
        }
      };

      const onTouchEnd = function () {
        isDragging = false;
        items.forEach((item, index) => {
          item.style.pointerEvents = 'all';
          list.removeEventListener('touchmove', onTouchMove);

          if (items.length > 1) {
            if (window.innerWidth < 750) {
              _this.snapToItemLeft(item, index, items, list);
            } else {
              if (list.dataset.layoutDirection == 'vertical') {
                _this.snapToItemTop(item, index, items, list);
              } else {
                _this.snapToItemLeft(item, index, items, list);
              }
            }
          }

          list.removeEventListener('touchend', onTouchEnd);
        });
      };

      window.addEventListener('touchend', () => {
        list.style.cursor = 'grab';
      });

      list.addEventListener('touchstart', onTouchStart, { passive: false });

      list.addEventListener('touchcancel', () => {
        if (isDragging) {
          onTouchEnd();
        }
      });
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
}